import React, { FC } from 'react';
import { Route, Router, Switch, useHistory } from 'react-router';

import { NotFound404Page } from 'src/components/pages/not-found-404-page/NotFound404Page';

import { RoutesHelper } from '../../helpers/RoutesHelper';
import { useConfiguration } from '../../providers/configurationProvider/ConfigurationProvider';
import { SiteScannerUiToggles } from '../../services/LocalTogglesService';
import { IssueDetailsPage } from '../issue-details-page/IssueDetailsPage';
import { ManageViewsPageWithAccess } from '../manage-views/ManageViewsPage';
import { PropertySettingsPage } from '../property-settings/PropertySettingsPage';
import { PropertySettingsPageV2 } from '../property-settings/PropertySettingsPageV2';
import { ScanRouter } from '../scan-analysis/ScanRouter';
import { ScanAndTrendsPage } from '../scan-and-trends/ScanAndTrendsPage';
import { CommonPagesPage } from '../scans-comparison/CommonPagesPage';
import { ScansComparisonPage } from '../scans-comparison/ScansComparisonPage';
import { UrlSetPage } from '../urlset/UrlSetPage';

const PropertyRouter: FC = () => {
	const basePath = RoutesHelper.getPropertyPagePath(':propertyId');
	const history = useHistory();
	const { getToggle } = useConfiguration();
	const useV2Settings = getToggle(SiteScannerUiToggles.ENABLE_PROPERTY_SETTINGS_V2);
	const SettingsPage = useV2Settings ? PropertySettingsPageV2 : PropertySettingsPage;
	return (
		<Router history={history}>
			<Switch>
				<Route
					exact
					path={RoutesHelper.getPropertyPagePath(':propertyId')}
					render={() => <ScanAndTrendsPage />}
				/>
				<Route
					exact
					path={RoutesHelper.getManageViewsPath(':propertyId')}
					render={() => <ManageViewsPageWithAccess />}
				/>
				<Route
					exact
					path={RoutesHelper.getPropertyTrendsPath(':propertyId')}
					render={() => <ScanAndTrendsPage />}
				/>
				<Route
					exact
					path={RoutesHelper.getPropertySettingsPagePath(':propertyId')}
					render={() => <SettingsPage />}
				/>
				<Route exact path={`${basePath}/scan-comparison`} render={() => <ScansComparisonPage />} />
				<Route
					exact
					path={`${basePath}/scan-comparison/common-pages`}
					render={() => <CommonPagesPage />}
				/>
				<Route
					exact
					path={RoutesHelper.getUrlSetPagePath(':propertyId', ':urlSetId')}
					component={UrlSetPage}
				/>
				<Route
					exact
					path={`${basePath}/scans/:scanId/issues/:issueId`}
					component={IssueDetailsPage}
				/>
				<Route path={`${basePath}/scans/:pathScanId`} render={() => <ScanRouter />} />
				<Route path="*" component={NotFound404Page} />
			</Switch>
		</Router>
	);
};

export { PropertyRouter };
